<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
       <v-row justify="center">
          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <v-skeleton-loader type="table"></v-skeleton-loader>
          </v-col>
       </v-row>
    </div>
    <div v-else>
      <v-row justify="center">
        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="text-h1 mb-2">
            {{usina.usi_nome}}
          </div>
          <div class="text font-italic mb-2" v-if="!projeto.usp_data_instalacao">
            *É necessário cadastrar a data de instalação da usina para o sistema calcular os valores dos cards abaixo.
          </div>
          <v-row class="mb-3">
            <v-col cols="12" sm="12" md="3" lg="3" xl="2">
              <v-card class="mb-3 px-2 py-3" elevation="2">
                <div class="imagem_usina mb-3"  :style="`background-image: url('${usina && usina.usi_imagem ? usina.usi_imagem : require('@/assets/img/bg_login.png')}')`"></div>
                <div class="text mb-2" v-if="projeto.usp_data_instalacao">Instalação: {{moment(projeto.usp_data_instalacao).format('DD/MM/YYYY')}}</div>
                <div class="text mb-2" v-if="projeto.usp_potencia">PV Capacidade: {{projeto.usp_potencia.replace('.', ',')}} kWp</div>
                <div class="text mb-2">Geração de hoje: {{usina.producao.hoje}}</div>
                <div class="text mb-2">Geração de {{moment().format('MMMM')}}: {{usina.producao.mes}}</div>
              </v-card>
              <v-card class="mb-3 px-2 py-3" elevation="2" v-if="usina.usi_clima_descricao">
                <div class="d-flex justify-center">
                  <img class="imagem_usina_clima" :src="`http://openweathermap.org/img/wn/${usina.usi_clima_icone}@2x.png`" />
                  <span class="text-capitalize pl-2 align-self-center">{{usina.usi_clima_descricao}}</span>
                </div>
                <div class="text mt-1 text-center">
                  Temperatura: {{usina.usi_clima_temperatura}}ºC
                </div>
              </v-card>
              <v-card elevation="2" class="px-2 py-6 text-center" v-if="usina.status">
                <div class="text-h2 text-primary mb-3">
                  Status
                </div>
                <div class="text-h3" :class="usina.status.uss_nome  === 'Online' ? 'text-green' : usina.status.uss_nome  === 'Offline' ? 'text-red' : usina.status.uss_nome  === 'Alerta' ? 'text-primary' : usina.status.uss_nome  === 'Não definido' ? 'text-yellow' : usina.status.uss_nome  === 'Sem conexão' ? 'text-blue' : usina.status.uss_nome  === 'Sem retorno' ? 'text-gray' : 'text-gray'">
                  <b>
                    {{usina.status.uss_nome}}
                  </b>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="9" lg="9" xl="10">
              <v-row>
                <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                  <v-card class="h-100 px-2 py-2 bg-primary text-center" elevation="2">
                    <div v-if="loadingCards" class="text-center mt-11 w-100">
                      <v-progress-circular
                        indeterminate
                        :size="50"
                        :width="5"
                        :color="'white'"
                      ></v-progress-circular>
                    </div>
                    <v-row v-else align="center" class="h-100" no-gutters>
                      <div class="text-h1 mb-2 w-100 text-white">
                        Geração
                      </div>
                      <div class="text-h1 w-100 text-white" v-if="cards && cards.geracao && cards.geracao.total">
                        {{cards.geracao.total}}
                        <span class="text text-white">
                          kWh Total
                        </span>
                      </div>
                      <div class="text-h3 w-100 text-white">
                        Dia / Mês / Ano
                      </div>
                      <div class="text mb-2 w-100 text-white">
                        ~ {{cards.geracao.dia}} / ~ {{cards.geracao.mes}} / ~ {{cards.geracao.ano}} kWh
                      </div>
                      <div class="text w-100 text-white">
                        {{cards.geracao.potencia}} potência de saída
                      </div>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                  <v-card class="h-100 px-2 py-2 bg-blue text-center" elevation="2">
                    <div v-if="loadingCards" class="text-center mt-11 w-100">
                      <v-progress-circular
                        indeterminate
                        :size="50"
                        :width="5"
                        :color="'white'"
                      ></v-progress-circular>
                    </div>
                    <v-row v-else align="center" class="h-100" no-gutters>
                      <div class="text-h1 mb-2 w-100 text-white">
                        Retorno
                      </div>
                      <div class="text-h1 mb-2 w-100 text-white">
                        {{$root.Formatter.floatToMoney(cards.renda.total)}}
                        <span class="text text-white">
                          Total
                        </span>
                      </div>
                      <div class="text-h3 w-100 text-white">
                        Dia / Mês / Ano
                      </div>
                      <div class="text w-100 text-white">
                        ~ {{$root.Formatter.floatToMoney(cards.renda.dia)}} / ~ {{$root.Formatter.floatToMoney(cards.renda.mes)}} / ~ {{$root.Formatter.floatToMoney(cards.renda.ano)}}
                      </div>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                  <v-card class="h-100 px-2 py-2 text-center bg-green" elevation="2">
                    <div v-if="loadingCards" class="text-center mt-11 mb-10 w-100">
                      <v-progress-circular
                        indeterminate
                        :size="50"
                        :width="5"
                        :color="'white'"
                      ></v-progress-circular>
                    </div>
                    <v-row align="center" class="h-100" no-gutters v-else>
                      <div class="text-h1 mb-3 w-100 text-white">
                        Planeta
                      </div>
                      <v-row class="w-100" justify="center" v-if="!cards.retorno">
                        <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0">
                          <div class="text text-white text-center">
                            <span>
                              Sem informações
                            </span>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="pr-4 w-100" justify="center" v-if="cards && cards.retorno && cards.retorno.equivalencias && cards.retorno.equivalencias.length">
                        <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0" v-for="(item, index) in cards.retorno.equivalencias" :key="index">
                          <div class="text text-white">
                            <i class="fa fad" :class="item.icon"></i>
                            <span>
                              {{item.name}}:
                            </span>
                            <b>
                              {{item.name === 'Arvores Ano' ? item.value : item.value.toFixed(2).replace('.', ',')}}
                            </b>
                          </div>
                        </v-col>
                      </v-row>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-3 mb-3">
                <div class="mw-100">
                  <v-autocomplete
                    autocomplete="off"
                    label="Período"
                    :items="periodos"
                    append-icon="expand_more"
                    @change="getDadosDash(1)"
                    outlined
                    v-model="periodo"
                    :loading="loadingSearch"
                    :disabled="loadingSearch"
                    hide-details
                  ></v-autocomplete>
                </div>
                <div class="ml-3" v-if="periodo !== 'dia'">
                  <VueCtkDateTimePicker
                    class="date-picker py-1"
                    locale="pt-BR"
                    :no-header="true"
                    :no-value-to-custom-elem="true"
                    :overlay="true"
                    :range="true"
                    :formatted="'L'"
                    :format="'YYYY-MM-DD'"
                    color="#EC6521"
                    :dark="$vuetify.theme.dark"
                    button-color="#EC6521"
                    :custom-shortcuts="labels"
                    :no-button="true"
                    :noClearButton="true"
                    :auto-close="true"
                    :loading="loadingSearch"
                    :disabled="loadingSearch"
                    v-on:callback="changeDates"
                    v-model="data_entrada"
                    :submit="retornoData()"
                  >
                    <v-btn class="px-2 py-1 pt-2 search_data" elevation="0" v-ripple="{ class: `success--text` }">
                      <b class="text text-primary">
                        Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                      </b>
                    </v-btn>
                  </VueCtkDateTimePicker>
                </div>
                <div class="ml-3" v-else>
                  <v-menu
                    ref="calendarData"
                    v-model="calendarData"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        label="Dia"
                        append-icon="calendar_today"
                        :loading="loadingSearch"
                        :disabled="loadingSearch"
                        hide-details
                        v-bind="attrs"
                        v-on="on"
                        v-model="dataFormatada"
                        v-mask="'##/##/####'"
                        @input="() => {
                          calendarData = false
                          dataDia = $root.Formatter.parseDate(dataFormatada)
                          updatePickerModalData = $root.Formatter.parseDate(dataFormatada)
                        }"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :picker-date.sync="updatePickerModalData"
                      year-icon="calendar_today"
                      prev-icon="chevron_left"
                      next-icon="chevron_right"
                      @change="getDadosDash()"
                      :loading="loadingSearch"
                      :disabled="loadingSearch"
                      hide-details
                      v-model="data"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <div class="ml-3">
                  <v-autocomplete
                    v-model="tipoFiltro"
                    autocomplete="off"
                    label="Tipo"
                    :items="tipos"
                    append-icon="expand_more"
                    outlined
                    :loading="loadingSearch"
                    :disabled="loadingSearch"
                    hide-details
                    @change="getDadosDash()"
                  ></v-autocomplete>
                </div>
              </v-row>
              <div ref="chartWidth" class="w-100">
                <div v-if="!loadingSearch">
                  <v-card class="px-2 py-2" elevation="2">
                    <div v-if="!hideChart && periodo == 'dia'">
                      <line-chart v-if="chartw" :options="optionsChartw" :width="larguraChart" :height="260" :data="chartData"></line-chart>
                      <line-chart v-if="chartkwh" :options="optionsChartkwh" :width="larguraChart" :height="260" :data="chartData"></line-chart>
                    </div>
                    <div v-if="!hideChart && periodo != 'dia'">
                      <bar-chart v-if="chartw" :options="optionsChartw" :width="larguraChart" :height="260" :data="chartData" :weather="weatherData"></bar-chart>
                      <bar-chart v-if="chartkwh" :options="optionsChartkwh" :width="larguraChart" :height="260" :data="chartData" :weather="weatherData"></bar-chart>
                    </div>
                  </v-card>
                </div>
                <v-card class="px-2 py-3 text-center" elevation="2" style="height: 274px" v-else>
                  <v-row align="center" justify="center" no-gutters class="h-100">
                    <v-progress-circular
                      indeterminate
                      :size="60"
                      :width="5"
                      :color="$vuetify.theme.dark ? 'white' : 'black'"
                    ></v-progress-circular>
                  </v-row>
                </v-card>
              </div>
            </v-col>
          </v-row>
          <div class="text-h2 text-primary mb-2">
            Inversores
          </div>
          <v-data-table
            :headers="header"
            :items="dados"
            :single-expand="true"
            :expanded.sync="expanded"
            expand-icon="expand_more"
            item-key="inversor.inv_id"
            show-expand
            @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
            class="elevation-1 base_table click_row"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-row v-if="loadingInversorData">
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <div class="py-3">
                      <v-skeleton-loader type="list-item-two-line, list-item-three-line, list-item-two-line"></v-skeleton-loader>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" md="8" lg="8" xl="8">
                    <div class="py-3 mt-4">
                      <v-skeleton-loader type="image"></v-skeleton-loader>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-else align="center">
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <div class="text-h3 text-primary mb-2 mt-2 text-center">
                      {{item.inversor.inv_serial}}
                    </div>
                    <v-simple-table class="base_table mt-2 mb-4">
                      <template v-slot:default>
                        <tbody>
                          <tr>
                            <td class="text-left">
                              Localização
                            </td>
                            <td class="text-center">
                              {{ item.inversor.inv_localizacao ? item.inversor.inv_localizacao : '-' }}
                            </td>
                          </tr>
                          <!-- <tr>
                            <td class="text-left">
                              Tempo de execução
                            </td>
                            <td class="text-center">
                              -
                            </td>
                          </tr> -->
                          <tr v-if="item.metricas">
                            <td class="text-left">
                              Atualização
                            </td>
                            <td class="text-center">
                              <!-- {{formatDateFront(item.metricas.umi_data, 'LL')}} às {{item.metricas.umi_hora}} -->
                              {{formatDateFront(item.metricas.timeUpload * 1000, 'LL')}} às {{formatDateFront(item.metricas.timeUpload * 1000, 'HH:mm')}}
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">
                              Tipo
                            </td>
                            <td class="text-center">
                              {{item.inversor.inv_tipo === 1 ? 'Monofásico' : item.inversor.inv_tipo === 2 ? 'Bifásico' : item.inversor.inv_tipo === 3 ? 'Trifásico' : '-'}}
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">
                              Temperatura
                            </td>
                            <td class="text-center">
                              <!-- {{item.metricas ? item.metricas.umi_temperatura : ' - '}} ºC -->
                              {{item.metricas ? item.metricas.internalTemp : ' - '}} ºC
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">
                              Potência de saída
                            </td>
                            <td class="text-center">
                              {{item.inversor.inv_potencia}} kW
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">
                              Geração do dia
                            </td>
                            <td class="text-center">
                              <!-- {{item.metricas ? item.metricas.umi_producao : 0}} kWh -->
                              {{item.metricas ? adjustProduction(item.metricas.dailyProduction) : 0 + ' kWh'}}
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">
                              Geração total
                            </td>
                            <td class="text-center">
                              <!-- {{item.metricas ? item.metricas.umi_acumulado : 0}} kWh -->
                              {{item.metricas ? adjustProduction(item.metricas.accumulated) : 0 + ' kWh'}}
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">
                              R - Voltagem | Corrente
                            </td>
                            <td class="text-center">
                              <!-- {{item.metricas ? item.metricas.umi_r_voltagem : 0}} v | {{item.metricas ? item.metricas.umi_r_corrente : 0}} a -->
                              {{item.metricas ? item.metricas.rVoltage : 0}} v | {{item.metricas ? item.metricas.rCurrent : 0}} a
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">
                              S - Voltagem | Corrente
                            </td>
                            <td class="text-center">
                              <!-- {{item.metricas ? item.metricas.umi_s_voltagem : 0}} v | {{item.metricas ? item.metricas.umi_s_corrente : 0}} a -->
                              {{item.metricas ? item.metricas.sVoltage : 0}} v | {{item.metricas ? item.metricas.sCurrent : 0}} a
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">
                              T - Voltagem | Corrente
                            </td>
                            <td class="text-center">
                              <!-- {{item.metricas ? item.metricas.umi_t_voltagem : 0}} v | {{item.metricas ? item.metricas.umi_t_corrente : 0}} a -->
                              {{item.metricas ? item.metricas.tVoltage : 0}} v | {{item.metricas ? item.metricas.tCurrent : 0}} a
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col cols="12" sm="12" md="8" lg="8" xl="8">
                    <v-row no-gutters class="mt-4 mb-2">
                      <div class="mw-100">
                        <v-autocomplete
                          autocomplete="off"
                          label="Período"
                          :items="periodosInversor"
                          append-icon="expand_more"
                          outlined
                          v-model="periodoInversor"
                          :loading="loadingSearchInversor"
                          :disabled="loadingSearchInversor"
                          hide-details
                          @change="updateFilterInversor(1)"
                        ></v-autocomplete>
                      </div>
                      <div class="ml-3" v-if="periodoInversor !== 'dia'">
                        <VueCtkDateTimePicker
                          class="date-picker py-1"
                          locale="pt-BR"
                          :no-header="true"
                          :no-value-to-custom-elem="true"
                          :overlay="true"
                          :range="true"
                          :formatted="'L'"
                          :format="'YYYY-MM-DD'"
                          color="#EC6521"
                          :dark="$vuetify.theme.dark"
                          button-color="#EC6521"
                          :custom-shortcuts="labels"
                          :no-button="true"
                          :noClearButton="true"
                          :auto-close="true"
                          :loading="loadingSearchInversor"
                          :disabled="loadingSearchInversor"
                          v-on:callback="changeDatesInversor"
                          v-model="data_entrada_inversor"
                          :submit="retornoDataInversor()"
                        >
                          <v-btn class="px-2 py-1 pt-2 search_data" elevation="0" v-ripple="{ class: `success--text` }">
                            <b class="text text-primary">
                              Período: {{ formatDateFront(deInversor, 'LL')}} - {{formatDateFront(ateInversor, 'LL') }}
                            </b>
                          </v-btn>
                        </VueCtkDateTimePicker>
                      </div>
                      <div class="ml-3" v-else>
                        <v-menu
                          ref="calendarDataInversor"
                          v-model="calendarDataInversor"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              label="Dia"
                              append-icon="calendar_today"
                              :loading="loadingSearchInversor"
                              :disabled="loadingSearchInversor"
                              hide-details
                              v-bind="attrs"
                              v-on="on"
                              v-model="dataFormatadaInversor"
                              v-mask="'##/##/####'"
                              @input="() => {
                                calendarDataInversor = false
                                dataDiaInversor = $root.Formatter.parseDate(dataFormatadaInversor)
                                updatePickerModalDataInversor = $root.Formatter.parseDate(dataFormatadaInversor)
                              }"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            :picker-date.sync="updatePickerModalDataInversor"
                            year-icon="calendar_today"
                            prev-icon="chevron_left"
                            next-icon="chevron_right"
                            :loading="loadingSearchInversor"
                            :disabled="loadingSearchInversor"
                            @change="updateFilterInversor()"
                            hide-details
                            v-model="dataInversor"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="ml-3">
                        <v-autocomplete
                          v-model="tipoInversor"
                          autocomplete="off"
                          label="Tipo"
                          :items="tiposInversor"
                          append-icon="expand_more"
                          outlined
                          :loading="loadingSearchInversor"
                          :disabled="loadingSearchInversor"
                          hide-details
                          @change="updateFilterInversor()"
                        ></v-autocomplete>
                      </div>
                    </v-row>
                    <div ref="chartWidthTwo">
                      <div class="py-3" v-if="loadingSearchInversor">
                        <v-card class="px-2 py-3 text-center" elevation="2" style="height: 400px">
                          <v-row align="center" justify="center" no-gutters class="h-100">
                            <v-progress-circular
                              indeterminate
                              :size="60"
                              :width="5"
                              :color="$vuetify.theme.dark ? 'white' : 'black'"
                            ></v-progress-circular>
                          </v-row>
                        </v-card>
                      </div>
                      <div v-else class="mt-3 mb-3">
                        <v-card class="px-2 py-2" elevation="2">
                          <div v-if="!hideChartTwo && periodoInversor == 'dia'">
                            <line-chart v-if="chartInversorw" :options="optionsChartInversorw" :width="larguraChartTwo" :height="350" :data="chartDataTwo"></line-chart>
                            <line-chart v-if="chartInversorkwh" :options="optionsChartInversorkwh" :width="larguraChartTwo" :height="350" :data="chartDataTwo"></line-chart>
                          </div>
                          <div v-if="!hideChartTwo && periodoInversor != 'dia'">
                            <bar-chart v-if="chartInversorw" :options="optionsChartInversorw" :width="larguraChartTwo" :height="350" :data="chartDataTwo"></bar-chart>
                            <bar-chart v-if="chartInversorkwh" :options="optionsChartInversorkwh" :width="larguraChartTwo" :height="350" :data="chartDataTwo"></bar-chart>
                          </div>
                        </v-card>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import LineChart from '@components/graficos/LineChart.vue'
import BarChart from '@components/graficos/BarChart.vue'
export default {
  components: {
    LineChart,
    BarChart,
    VueCtkDateTimePicker
  },
  data () {
    return {
      loading: true,
      panel: [],
      expanded: [],
      uuid: '',
      usina: '',
      loadingInversor: false,
      loadingStatus: false,
      loadingSearchInversor: false,
      dadosStatus: [],
      header: [
        {
          text: 'ID',
          align: 'start',
          value: 'inversor.inv_id'
        },
        { text: 'Marca', value: 'inversor.inv_marca', align: 'center' },
        { text: 'Serial', value: 'inversor.inv_serial', align: 'center' },
        { text: 'Status', value: 'inversor.status.uss_nome', align: 'center' },
        { text: 'Garantia', value: 'inversor.inv_garantia', align: 'center' },
        // { text: 'Gerador', value: 'inversor.gerador.uge_nome', align: 'center' },
        { text: '', value: 'data-table-expand' }
      ],
      dados: [],
      dataDia: moment(new Date()).format('YYYY-MM-DD'),
      calendarData: false,
      data: moment(new Date()).format('YYYY-MM-DD'),
      dataFormatada: moment(new Date()).format('DD/MM/YYYY'),
      updatePickerModalData: '',
      de: moment().startOf('month').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      loadingSearch: false,
      periodo: 'dia',
      periodos: [
        {
          text: 'Dia',
          value: 'dia'
        },
        {
          text: 'Mês',
          value: 'mes'
        },
        {
          text: 'Ano',
          value: 'ano'
        }
      ],
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ],
      tipoFiltro: 'potencia',
      tipos: [
        {
          text: 'Potência de saída',
          value: 'potencia'
        },
        {
          text: 'Geração total/produção',
          value: 'producao'
        }
      ],
      chartData: {},
      weatherData: {},
      chartDataTwo: {},
      loadingInversorData: false,
      dataDiaInversor: moment(new Date()).format('YYYY-MM-DD'),
      calendarDataInversor: false,
      dataInversor: moment(new Date()).format('YYYY-MM-DD'),
      dataFormatadaInversor: moment(new Date()).format('DD/MM/YYYY'),
      updatePickerModalDataInversor: '',
      deInversor: moment().startOf('month').format('YYYY-MM-DD'),
      ateInversor: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada_inversor: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      periodosInversor: [
        {
          text: 'Dia',
          value: 'dia'
        },
        {
          text: 'Mês',
          value: 'mes'
        },
        {
          text: 'Ano',
          value: 'ano'
        }
      ],
      tiposInversor: [
        {
          text: 'Potência de saída',
          value: 'potencia'
        },
        {
          text: 'Geração total/produção',
          value: 'producao'
        }
      ],
      tipoInversor: 'potencia',
      periodoInversor: 'dia',
      inversorData: '',
      timer: '',
      loadingCards: false,
      cards: [],
      loadingProjeto: false,
      projeto: [],
      hideChart: false,
      larguraChart: 0,
      hideChartTwo: false,
      larguraChartTwo: 0,
      chartInversorw: false,
      chartInversorkwh: false,
      optionsChartInversorkwh: {
        responsive: false,
        maintainAspectRatio: true,
        legend: { display: false },
        plugins: {
          legend: {
            position: 'top'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return value + 'kWh'
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return tooltipItem.value.replace('.', ',') + ' kWh'
            }
          }
        }
      },
      optionsChartInversorw: {
        responsive: false,
        maintainAspectRatio: true,
        legend: { display: false },
        plugins: {
          legend: {
            position: 'top'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return value + 'W'
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return tooltipItem.value.replace('.', ',') + ' W'
            }
          }
        }
      },
      chartw: false,
      chartkwh: false,
      optionsChartw: {
        responsive: false,
        maintainAspectRatio: true,
        legend: { display: false },
        plugins: {
          legend: {
            position: 'top'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return value + 'W'
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return tooltipItem.value.replace('.', ',') + ' W'
            }
          }
        }
      },
      optionsChartkwh: {
        responsive: false,
        maintainAspectRatio: true,
        legend: { display: false },
        plugins: {
          legend: {
            position: 'top'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return value + 'kWh'
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return tooltipItem.value.replace('.', ',') + ' kWh'
            }
          }
        }
      }
    }
  },
  watch: {
    expanded () {
      if (this.expanded.length > 0) {
        this.getDadosInversor(this.expanded[0])
      }
    },
    data () {
      this.dataFormatada = moment(this.data).format('L')
      this.dataDia = this.$root.Formatter.parseDate(this.dataFormatada)
      this.calendarData = false
    },
    dataInversor () {
      this.dataFormatadaInversor = moment(this.dataInversor).format('L')
      this.dataDiaInversor = this.$root.Formatter.parseDate(this.dataFormatadaInversor)
      this.calendarDataInversor = false
    }
  },
  methods: {
    moment,
    async getDadosInversor (a) {
      this.inversorData = JSON.parse(JSON.stringify(a))
      this.updateFilterInversor()
    },
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          this.applyFilter()
        }
      }
    },
    applyFilter () {
      this.getDadosDash()
    },
    loadContent () {
      this.loadFunctions()
    },
    loadFunctions () {
      this.getUsina()
      this.getProjeto()
      this.getDadosCards()
      this.getInversores()
      this.getDadosDash()
    },
    async getProjeto () {
      this.loadingProjeto = true
      Api.get('usinas/' + this.uuid + '/projeto')
        .then((response) => {
          this.loadingProjeto = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.projeto = response.data
        })
        .catch((error) => {
          this.loadingProjeto = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da usina!',
            color: 'error'
          })
        })
    },
    async getDadosCards () {
      this.loadingCards = true
      Api.get('usinas/' + this.uuid + '/dashboard/cards')
        .then((response) => {
          this.loadingCards = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'warning'
            })
          }
          this.cards = response.data
        })
        .catch((error) => {
          this.loadingCards = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados dos cards!',
            color: 'error'
          })
        })
    },
    async getDadosDash (selecionadoDia) {
      this.loadingSearch = true
      this.hideChart = true
      let endpoint = ''
      // if (this.tipoFiltro === 'producao') {
      //   if (this.periodo !== 'mes') {
      //     this.de = moment().startOf('month').format('YYYY-MM-DD')
      //     this.ate = moment().endOf('month').format('YYYY-MM-DD')
      //     this.data_entrada.start = this.de
      //     this.data_entrada.end = this.ate
      //   }
      //   this.periodo = 'mes'
      //   this.periodos = [
      //     {
      //       text: 'Dia',
      //       value: 'dia'
      //       // disabled: true
      //     },
      //     {
      //       text: 'Mês',
      //       value: 'mes'
      //     },
      //     {
      //       text: 'Ano',
      //       value: 'ano'
      //     }
      //   ]
      // } else {
      //   this.periodos = [
      //     {
      //       text: 'Dia',
      //       value: 'dia'
      //     },
      //     {
      //       text: 'Mês',
      //       value: 'mes'
      //     },
      //     {
      //       text: 'Ano',
      //       value: 'ano'
      //     }
      //   ]
      // }
      this.periodos = [
        {
          text: 'Dia',
          value: 'dia'
          // disabled: true
        },
        {
          text: 'Mês',
          value: 'mes'
        },
        {
          text: 'Ano',
          value: 'ano'
        }
      ]
      if (selecionadoDia) {
        if (this.periodo === 'dia') {
          this.de = moment(new Date()).format('YYYY-MM-DD')
          this.ate = moment(new Date()).format('YYYY-MM-DD')
          this.data_entrada.start = this.de
          this.data_entrada.end = this.ate
          this.dataDia = moment(new Date()).format('YYYY-MM-DD')
          this.data = moment(new Date()).format('YYYY-MM-DD')
          this.dataFormatada = moment(new Date()).format('DD/MM/YYYY')
        }
        if (this.periodo === 'mes') {
          this.de = moment().startOf('month').format('YYYY-MM-DD')
          this.ate = moment().endOf('month').format('YYYY-MM-DD')
          this.data_entrada.start = this.de
          this.data_entrada.end = this.ate
        }
        if (this.periodo === 'ano') {
          this.de = moment().startOf('year').format('YYYY-MM-DD')
          this.ate = moment().endOf('year').format('YYYY-MM-DD')
          this.data_entrada.start = this.de
          this.data_entrada.end = this.ate
        }
      }
      endpoint += this.tipoFiltro ? '?tipo=' + this.tipoFiltro : '?tipo='
      endpoint += this.periodo ? '&tipo_periodo=' + this.periodo : '&tipo_periodo='
      endpoint += this.de ? '&data=&&de=' + this.de : '&data=&&de='
      endpoint += this.ate ? '&ate=' + this.ate : '&ate='
      if (this.periodo === 'dia') {
        endpoint = ''
        endpoint += this.tipoFiltro ? '?tipo=' + this.tipoFiltro : '?tipo='
        endpoint += this.periodo ? '&tipo_periodo=' + this.periodo : '&&detipo_periodo='
        endpoint += '&data=' + this.data
      }
      this.chartData = null
      this.weatherData = null
      Api.get('usinas/' + this.uuid + '/dashboard/geral' + endpoint)
        .then((response) => {
          this.loadingSearch = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (this.tipoFiltro === 'potencia') {
            this.chartkwh = false
            this.chartw = true
          } else {
            this.chartkwh = true
            this.chartw = false
          }
          this.chartData = {
            labels: response.data.labels,
            datasets: [
              {
                label: response.data.label,
                backgroundColor: '#4393B6',
                lineTension: '0.1',
                data: response.data.data
              }
            ]
          }

          if (response.data.clima) {
            this.weatherData = response.data.clima
          }
          setTimeout(() => {
            this.larguraChart = this.$refs.chartWidth.clientWidth - 15
            this.hideChart = false
          }, 200)
          this.cancelAutoUpdate()
          this.startAutoUpdate()
        })
        .catch((error) => {
          this.hideChart = false
          this.loadingSearch = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados do dashboard!',
            color: 'error'
          })
        })
    },
    async getUsina () {
      this.loading = true
      Api.get('usinas/' + this.uuid)
        .then((response) => {
          this.loading = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.usina = JSON.parse(JSON.stringify(response.data))
        })
        .catch((error) => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da usina!',
            color: 'error'
          })
        })
    },
    async getInversores () {
      this.loading = true
      await Api.get('usinas/' + this.uuid + '/dashboard/inversores')
        .then(res => {
          let cha = []
          if (res.data.length) {
            res.data.map(item => {
              item.inversor.inv_garantia = item.inversor.inv_garantia ? moment(item.inversor.inv_garantia).format('DD/MM/YYYY') : '--'
              item.inversor.inv_modelo = item.inversor.inv_modelo ? item.inversor.inv_modelo : '-'

              if (!item.inversor.gerador) {
                item.inversor = {...item.inversor, gerador: { uge_nome: '--' }}
              }
              // item.datSelect = 'Dia'
              // item.de = moment().startOf('month').format('YYYY-MM-DD')
              // item.ate = moment(new Date()).format('YYYY-MM-DD')
              // item.valor = 'Tempo de execução'
              // item.data_entrada = {
              //   start: moment().startOf('month').format('YYYY-MM-DD'),
              //   end: moment(new Date()).format('YYYY-MM-DD')
              // }
            })
            cha = res.data
          }
          this.dados = cha
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os inversores!',
            color: 'error'
          })
        })
    },
    async getStatusData (total) {
      this.loadingStatus = true
      let dad = {
        kwh_average_month: Number(total) / 12
      }
      await Api.post('usinas/' + this.uuid + '/equivalencias', dad)
        .then(res => {
          this.dadosStatus = res.data.equivalencias
          this.loadingStatus = false
        })
        .catch(err => {
          this.loadingStatus = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os status!',
            color: 'error'
          })
        })
    },
    adjustProduction (prod) {
      if (prod > 1000) {
        return (prod / 1000).toFixed(2) + ' MWh'
      }

      return prod.toFixed(2) + ' kWh'
    },
    changeDatesInversor (dates) {
      this.deInversor = dates.start
      this.ateInversor = dates.end
    },
    retornoDataInversor () {
      if (this.data_entrada_inversor.start !== this.deInversor || this.data_entrada_inversor.end !== this.ateInversor) {
        if (this.data_entrada_inversor.end !== null) {
          this.deInversor = this.data_entrada_inversor.start
          this.ateInversor = this.data_entrada_inversor.end
          this.updateFilterInversor()
        }
      }
    },
    updateFilterInversor (selecionadoDia) {
      this.loadingSearchInversor = true
      this.hideChartTwo = true
      let endpoint = ''
      // if (this.tipoInversor === 'producao') {
      //   if (this.periodoInversor === 'mes') {
      //     this.deInversor = moment().startOf('month').format('YYYY-MM-DD')
      //     this.ateInversor = moment().endOf('month').format('YYYY-MM-DD')
      //     this.data_entrada_inversor.start = this.deInversor
      //     this.data_entrada_inversor.end = this.ateInversor
      //   }
      //   // this.periodoInversor = 'mes'
      //   this.periodosInversor = [
      //     {
      //       text: 'Dia',
      //       value: 'dia'
      //       // disabled: true
      //     },
      //     {
      //       text: 'Mês',
      //       value: 'mes'
      //     },
      //     {
      //       text: 'Ano',
      //       value: 'ano'
      //     }
      //   ]
      // } else {
      //   this.periodosInversor = [
      //     {
      //       text: 'Dia',
      //       value: 'dia'
      //     },
      //     {
      //       text: 'Mês',
      //       value: 'mes'
      //     },
      //     {
      //       text: 'Ano',
      //       value: 'ano'
      //     }
      //   ]
      // }
      this.periodosInversor = [
        {
          text: 'Dia',
          value: 'dia'
        },
        {
          text: 'Mês',
          value: 'mes'
        },
        {
          text: 'Ano',
          value: 'ano'
        }
      ]
      if (selecionadoDia) {
        if (this.periodoInversor === 'dia') {
          this.deInversor = moment(new Date()).format('YYYY-MM-DD')
          this.ateInversor = moment(new Date()).format('YYYY-MM-DD')
          this.data_entrada_inversor.start = this.deInversor
          this.data_entrada_inversor.end = this.ateInversor
          this.dataDiaInversor = moment(new Date()).format('YYYY-MM-DD')
          this.dataInversor = moment(new Date()).format('YYYY-MM-DD')
          this.dataFormatadaInversor = moment(new Date()).format('DD/MM/YYYY')
        }
        if (this.periodoInversor === 'mes') {
          this.deInversor = moment().startOf('month').format('YYYY-MM-DD')
          this.ateInversor = moment().endOf('month').format('YYYY-MM-DD')
          this.data_entrada_inversor.start = this.deInversor
          this.data_entrada_inversor.end = this.ateInversor
        }
        if (this.periodoInversor === 'ano') {
          this.deInversor = moment().startOf('year').format('YYYY-MM-DD')
          this.ateInversor = moment().endOf('year').format('YYYY-MM-DD')
          this.data_entrada_inversor.start = this.deInversor
          this.data_entrada_inversor.end = this.ateInversor
        }
      }
      endpoint += this.tipoInversor ? '?tipo=' + this.tipoInversor : '?tipo='
      endpoint += this.periodoInversor ? '&tipo_periodo=' + this.periodoInversor : '&tipo_periodo='
      endpoint += this.deInversor ? '&data=&&de=' + this.deInversor : '&data=&&de='
      endpoint += this.ateInversor ? '&ate=' + this.ateInversor : '&ate='
      if (this.periodoInversor === 'dia') {
        endpoint = ''
        endpoint += this.tipoInversor ? '?tipo=' + this.tipoInversor : '?tipo='
        endpoint += this.periodoInversor ? '&tipo_periodo=' + this.periodoInversor : '&&detipo_periodo='
        endpoint += '&data=' + this.dataInversor
      }
      this.chartDataTwo = {}
      Api.get('usinas/' + this.uuid + '/dashboard/inversor/' + this.inversorData.inversor.uuid_inv_id + endpoint)
        .then((response) => {
          this.loadingSearchInversor = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (this.tipoInversor === 'potencia') {
            this.chartInversorkwh = false
            this.chartInversorw = true
          } else {
            this.chartInversorkwh = true
            this.chartInversorw = false
          }
          this.chartDataTwo = {
            labels: response.data.labels,
            datasets: [
              {
                label: response.data.label,
                backgroundColor: '#4393B6',
                lineTension: '0.1',
                data: response.data.data
              }
            ]
          }
          setTimeout(() => {
            this.larguraChartTwo = this.$refs.chartWidthTwo.clientWidth - 15
            this.hideChartTwo = false
          }, 200)
          this.cancelAutoUpdate()
          this.startAutoUpdate()
        })
        .catch((error) => {
          this.loadingSearchInversor = false
          this.hideChartTwo = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados do inversor!',
            color: 'error'
          })
        })
    },
    cancelAutoUpdate () {
      clearInterval(this.timer)
      this.timer = ''
    },
    startAutoUpdate () {
      this.timer = setInterval(this.loadContent, 300000)
    }
  },
  beforeDestroy () {
    this.cancelAutoUpdate()
  },
  created () {
    this.uuid = this.$route.params.uuid
    this.loadContent()
    this.timer = setInterval(this.loadContent, 300000)
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.imagem_usina {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 200px;
  width: 100%;
}
.imagem_usina_clima {
  width: 40px;
}
.mw-100 {
  max-width: 100px;
}
.date-picker {
  .search_data {
    margin-top: -4px;
    min-height: 40px!important;
  }
}
>>> .click_row {
  tr {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/visaoGeral/VisaoGeralInterna.vue